import { render } from "./AttendanceConfig.vue?vue&type=template&id=528d96e1"
import script from "./AttendanceConfig.vue?vue&type=script&lang=js"
export * from "./AttendanceConfig.vue?vue&type=script&lang=js"

import "./AttendanceConfig.vue?vue&type=style&index=0&id=528d96e1&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__